export const isRetriable = (statusCode?: number): boolean => {
  if (!statusCode) return true
  if (statusCode === 429) return true
  if (statusCode >= 500 && statusCode < 600) return true

  return false
}
